import { useQuery } from "@tanstack/react-query";
import { container } from "tsyringe";
import { PREVIEW_DATA } from "../../../constants/queryKey";
import { ViewService } from "../view.service";

export const getPreviewDataFn = async (
  url: string,
  headers: Record<string, string>
) => {
  const viewService = container.resolve(ViewService);
  return viewService.getPreviewData(url, headers);
};

export const usePreviewData = (
  url: string,
  headers: Record<string, string>,
  enabled: boolean
) => {
  return useQuery({
    queryKey: [PREVIEW_DATA, url, headers],
    queryFn: () => getPreviewDataFn(url, headers),
    enabled,
    retry: 0
  });
};
